



















































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class IndustrySelector extends Vue {
  @Prop() value!: string

  // 行业数量
  get industryCount () {
    return Object.keys(this.$i18n.messages.en.industries).length
  }

  get selectedIndustry () {
    return this.value
  }
  set selectedIndustry (val: string) {
    this.$emit('input', val)
  }
}
